;(function () {
  'use strict'

  angular.module('contrast.servers', [
    'ngRoute',
    'ngAnimate',
    'route-segment',
    'view-segment',
    'angularMoment',
    'xeditable'
  ])
  angular.module('contrast.servers.syslog', [])
})()
